import { render, staticRenderFns } from "./NewsListItems.vue?vue&type=template&id=839f2620"
import script from "./NewsListItems.vue?vue&type=script&lang=js"
export * from "./NewsListItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports